import Select from 'src/components/primitives/Select/Select';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import { WithClassName } from 'src/utils/UtilityTypes';
import { HistoryTableFilterStore } from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';

export type MarketTypeFilter = 'perp' | 'spot';
type MarketTypeFilterOption = {
	label: string;
	value: MarketTypeFilter;
};

const MARKET_TYPE_FILTER_OPTIONS: MarketTypeFilterOption[] = [
	{ label: 'Perps', value: 'perp' },
	{ label: 'Spot', value: 'spot' },
];

interface Props extends WithClassName {
	filters: HistoryTableFilterStore['orders'];
	handleTableFilterChange: (selectedFilter: MarketTypeFilter) => void;
}

export default function OrderHistoryMarketTypeFilter({
	className,
	filters,
	handleTableFilterChange,
}: Props) {
	const {
		selectOptions,
		selectedOption,
		value,
		onValueChange,
		open,
		onOpenChange,
	} = useSelect({
		options: MARKET_TYPE_FILTER_OPTIONS,
		onSelectedValueChange: handleTableFilterChange,
		selectedValue: filters.marketType,
	});

	return (
		<Select.Root
			open={open}
			onOpenChange={onOpenChange}
			value={value}
			onValueChange={onValueChange}
		>
			<Select.Trigger label="Type" className={className}>
				{selectedOption?.label ?? 'Select'}
			</Select.Trigger>
			<Select.Options>
				{selectOptions.map((option) => (
					<Select.Option key={option.value} value={option.value}>
						{option.label}
					</Select.Option>
				))}
			</Select.Options>
		</Select.Root>
	);
}
